import ApiService from "../../services/ApiService";

export function getFiltersDiploma(params = {}, callback) {
    return async dispatch => {
        await ApiService.getDiplomaFilters(params)
            .then(result => {
                if (typeof callback === 'function') {
                    callback(result.communicationProgram);
                }
            },
                error => {
                    throw ({ error: error, message: 'An error ocurred' });
                })

    }
}

export function getDiplomaFile(params = {}, callback){
    return async dispatch => {
        await ApiService.getPrintDiploma(params)
            .then(result => {
                if (typeof callback === 'function') {
                   callback(result);
                }
            },
                error => {
                    throw ({ error: error, message: 'An error ocurred' });
                })

    }
}

export async function getDiplomaFileAsync (params = {}){
    var response = await ApiService.getPrintDiploma(params);
    return response;
}